import { Routes } from '@angular/router';
import { LoginComponent } from './login';
import { InicioComponent } from './inicio';
import { EmpresaComponent } from './empresa';
import { SubastasComponent } from './subastas';
import { ComoFuncionaComponent } from './como-funciona';
import { SubastasDetalleComponent } from './subastas-detalle';
import { CondicionesSubastaComponent } from './condiciones-subasta';
import { ResumenPreciosComponent } from './resumen-precios';
import { ContactoComponent } from './contacto';
import { RegistroComponent } from './registro/registro.component';
import { RecuperaContrasenaComponent } from './recupera-contrasena';
import { PropiedadesRuralesComponent } from './propiedades-rurales/propiedades-rurales.component';
import { PropiedadesRuralesDetalleComponent } from './propiedades-rurales-detalle/propiedades-rurales-detalle.component';
import { CambiarContrasenaComponent } from './cambiar-contrasena';
var ɵ0 = { registro: true }, ɵ1 = { registro: false };
var appRoutes = [
    { path: 'login', component: LoginComponent },
    { path: '', component: InicioComponent },
    { path: 'empresa', component: EmpresaComponent },
    { path: 'subastas', component: SubastasComponent },
    { path: 'subastas/:id', component: SubastasDetalleComponent },
    { path: 'como-funciona', component: ComoFuncionaComponent },
    { path: 'condiciones-subasta', component: CondicionesSubastaComponent },
    { path: 'resumen-precios', component: ResumenPreciosComponent },
    { path: 'resumen-precios/:id', component: ResumenPreciosComponent },
    { path: 'contacto', component: ContactoComponent },
    { path: 'registro', component: RegistroComponent, data: ɵ0 },
    {
        path: 'mi-cuenta',
        component: RegistroComponent,
        data: ɵ1
    },
    { path: 'resumen-precios/:id', component: SubastasDetalleComponent },
    { path: 'recuperar-contrasena', component: RecuperaContrasenaComponent },
    { path: 'propiedades-rurales', component: PropiedadesRuralesComponent },
    {
        path: 'propiedades-rurales/:id',
        component: PropiedadesRuralesDetalleComponent
    },
    { path: 'cambiar-contrasena/:token', component: CambiarContrasenaComponent },
    // otherwise redirect to home
    { path: '**', redirectTo: '' }
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1 };
